import { PIN_LIMIT_ERROR } from 'components/widgets/Modal/constants';

export const getPinLimitError = (pinTimeout: number) => ({
  errorMessage: `You have tried too many times. Try again in ${pinTimeout} minute${pinTimeout > 1 ? 's.' : '.'}`,
  errorCode: PIN_LIMIT_ERROR,
});
